import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateSolicitudGastosFarmaciaByID = () => {
  const [loadingUpdateSolicitudGastosFarmaciaById, setLoadingUpdateSolicitudGastosFarmaciaById] = useState(false);
  const [successUpdateSolicitudGastosFarmaciaById, setSuccessUpdateSolicitudGastosFarmaciaById] = useState(false);
  const [errorUpdateSolicitudGastosFarmaciaById, setErrorUpdateSolicitudGastosFarmaciaById] = useState(null);
  const [dataUpdateSolicitudGastosFarmaciaById, setDataSolicitudGastosFarmacia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const updateSolicitudGastosFarmaciaById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingUpdateSolicitudGastosFarmaciaById(true);
    setSuccessUpdateSolicitudGastosFarmaciaById(false);
    setErrorUpdateSolicitudGastosFarmaciaById(null);

    try {
      const payload = {
        ...data,
        Id: data?.Id ?? formId,
        UsuarioId: data?.UsuarioId ?? userId,
      };
      const res = await apiRecord.updateSolicitudGastosContingenciaProfesionalFarmaciaByID(userId, formId, payload);

      setSuccessUpdateSolicitudGastosFarmaciaById(true);
      setDataSolicitudGastosFarmacia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      console.error("Error en updateSolicitudGastosFarmaciaById:", err);
      setErrorUpdateSolicitudGastosFarmaciaById(err.response?.data ?? err);

      throw err;
    } finally {
      setLoadingUpdateSolicitudGastosFarmaciaById(false);
    }
  };

  return {
    updateSolicitudGastosFarmaciaById,
    loadingUpdateSolicitudGastosFarmaciaById,
    successUpdateSolicitudGastosFarmaciaById,
    errorUpdateSolicitudGastosFarmaciaById,
    dataUpdateSolicitudGastosFarmaciaById
  };
};

export default useUpdateSolicitudGastosFarmaciaByID;
